import React, {memo} from "react";
import {Avatar, Box, IconButton, Tooltip, Typography} from "@mui/material";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import CloseIcon from "@mui/icons-material/Close";

const ChatbotHeader = ({classes, logo, onMinimize, onClose}) => (
  <Box className={classes.chatbotWrapper}>
    <Avatar
      src={logo}
      alt="BreachRx Logo"
      variant="square"
      sx={{width: 50, height: 50, "& img": {objectFit: "contain"}}}
    />
    <Typography variant="h5" display="flex">
      Rex AI<Typography sx={{verticalAlign: "super"}}>&trade;</Typography>
      <Typography component="span" variant="h5" ml={0.5}>
        RegScout
      </Typography>
      <Typography sx={{verticalAlign: "super"}}>&reg;</Typography>
    </Typography>
    <Box>
      <IconButton
        onClick={onMinimize}
        className={classes.chatbotIcon}
        sx={(theme) => ({marginLeft: theme.spacing(-5)})}
        id="minimize-chat"
        aria-label="minimize chat"
      >
        <Tooltip title="Minimize conversation" placement="top">
          <CloseFullscreenIcon sx={{fill: "gray"}} />
        </Tooltip>
      </IconButton>
      <IconButton
        onClick={onClose}
        className={classes.chatbotIcon}
        id="close-chat"
        aria-label="close chat"
      >
        <Tooltip title="Close & end conversation" placement="top">
          <CloseIcon sx={{fill: "gray"}} />
        </Tooltip>
      </IconButton>
    </Box>
  </Box>
);

export default memo(ChatbotHeader);
